<template>
  <div class="table-of-contents">
    <ul class="table-of-contents__chapters">
      <li class="table-of-contents__chapter">
        <div class="chapter-title">Clovyr General Help</div>
        <ul class="table-of-contents__sections">
          <li
            @click="handleSelection({ name: 'recovery-kit-help', chapter: 'Clovyr General Help' })"
            class="table-of-contents__section"
          >
            <div class="section-title">Recovery Kit Help</div>
          </li>
        </ul>
      </li>
      <li class="table-of-contents__chapter">
        <div class="chapter-title">Help with Clovyr Code</div>
        <ul class="table-of-contents__sections">
          <li
            @click="handleSelection({ name: 'getting-started', chapter: 'Help with Clovyr Code' })"
            class="table-of-contents__section"
          >
            <div class="section-title">Help with Clovyr Code</div>
          </li>

          <li
            @click="
              handleSelection({ name: 'launching-clovyr-code', chapter: 'Help with Clovyr Code' })
            "
            class="table-of-contents__section"
          >
            <div class="section-title">Launching Clovyr Code</div>
          </li>
        </ul>
      </li>
      <li class="table-of-contents__chapter">
        <div class="chapter-title">Contact Us</div>
        <ul class="table-of-contents__sections">
          <li class="table-of-contents__section">
            <a href="mailto:support@clovyr.io">
              <div class="section-title">Email Support</div>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TableOfContents',
  methods: {
    handleSelection(page) {
      this.$emit('item-select', page);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/core/layout/grid-vars';
@use 'styles/core/typography/type';

$item-spacing: grid-vars.space(2.2);

.table-of-contents {
  &__chapter {
    margin-bottom: grid-vars.space(4);
  }

  .chapter-title {
    @include type.text--h3;

    margin-bottom: $item-spacing;
    color: colors.color(grey);
  }

  .section-title {
    @include type.text--h4;

    cursor: pointer;

    &:hover {
      color: colors.color(action);
    }
  }

  &__section:not(:last-child) {
    .section-title {
      margin-bottom: $item-spacing;
    }
  }
}
</style>
